import axios from "src/utils/axios";
import authService from "src/services/authService";
import { Auth } from "aws-amplify";

export const LOGIN_REQUEST = "@account/login-request";
export const LOGIN_SUCCESS = "@account/login-success";
export const LOGIN_FAILURE = "@account/login-failure";
export const SILENT_LOGIN = "@account/silent-login";
export const LOGOUT = "@account/logout";
export const REGISTER = "@account/register";
export const UPDATE_PROFILE = "@account/update-profile";

export function login(email, password) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      const user = await authService.loginWithUsernameAndPassword(email, password);
      if (user.challengeName !== "NEW_PASSWORD_REQUIRED") {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            user
          }
        });
      }
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function setNewPassword(username, oldPwd, newPwd) {
  return async (dispatch) => {
    try {
      console.log("set new pwd");
      console.log(oldPwd)
      console.log(newPwd);
      dispatch({ type: LOGIN_REQUEST });

      const user = await authService.handleNewPasswordRequired(username, oldPwd, newPwd);

      // dispatch({
      //   type: LOGIN_SUCCESS,
      //   payload: {
      //     user
      //   }
      // });
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function setUserData(user) {
  return (dispatch) => dispatch({
    type: SILENT_LOGIN,
    payload: {
      user
    }
  });
}

export function logout() {
  return async (dispatch) => {
    authService.logout();

    dispatch({
      type: LOGOUT
    });
  };
}

export function register(values) {
  return async () => {
    const newUser = await Auth.signUp({
      username: values.username,
      password: values.password,

      attributes: {
        "email": values.email,
        "given_name": values.firstName,
        "family_name": values.lastName
      }
    });
    await axios.post(`${process.env.REACT_APP_API_URL}/student`, {
      userName: values.username,
      given_name: values.firstName,
      family_name: values.lastName,
      email: values.email
    }).then(e => console.log(e)).catch(e => console.log(e))
  };
}

export function updateProfile(update) {

  const request = axios.post("/api/account/profile", { update });

  return (dispatch) => {
    request.then((response) => dispatch({
      type: UPDATE_PROFILE,
      payload: response.data
    }));
  };
}

export function confirmSignUp(values) {
  return async () => {
    await Auth.confirmSignUp(values.username, values.code);
  }
}
